<template>
  <div v-if="images && images.length" class="event-gallery">

    <SplideCarousel :options="splideOptions">
      <SplideSlide
        v-for="(image, index) in images"
        :key="image.id"
      >
        <div class="carousel-image-container">
          <img
            :src="image.url"
            :alt="image.alt"
            @click="showImage(image, index)"
          />
        </div>

        <div class="text-center carousel-info my-2">
          <span>{{ index + 1 }} / {{ images.length }}</span>
          
        </div>
      </SplideSlide>
    </SplideCarousel>

    <!-- Overlay per visualizzare l'immagine a schermo intero con descrizione -->
    <div v-if="fullscreenImage" class="overlay" @click="closeImage">
        <div class="fullscreen-container">
          <!-- Bottone "X" per chiudere l'immagine -->
        <button class="close-btn" @click.stop="closeImage">&times;</button>
          <img :src="fullscreenImage.url" class="fullscreen-image" :alt="fullscreenImage.alt">
          <div v-if="fullscreenImage.description" class="image-description ">
            <p>{{ fullscreenImage.description }}</p>
          </div>
        </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'EventImages',
  props: {
    images: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      fullscreenImage: null,
      splideOptions: {
        type: 'slide',
        perPage: 1,
        focus: 'center',
        gap: '1rem',
        pagination: false,
        arrows: true
      }
    }
  },
  methods: {
    showImage(image) {
      this.fullscreenImage = image;
    },
    closeImage() {
      this.fullscreenImage = null;
    }
  }
}
</script>

<style scoped>
.carousel-image-container {
  height: 500px;
  width: 100%; /* assicurati che il contenitore occupi tutta la larghezza */
  overflow: hidden; /* taglia tutto ciò che esce */
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel-image-container img {
  width: 100%;
  max-width: 900px;   /* limite massimo su schermi grandi */
  height: auto;
  max-height: 100%;   /* non supera i 500px del container */
  object-fit: contain;
  cursor: pointer;
}
.overlay {
  z-index: 10000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}
.fullscreen-container{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.fullscreen-image {
  max-width: 90%;
  max-height: 90%;
}
/* Posiziona il bottone "X" in alto a destra */
.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: transparent;
  border: none;
  color: white;
  font-size: 30px;
  font-weight: bold;
  cursor: pointer;
  z-index: 10001;
}

.close-btn:hover {
  color: gray;
}

/* LO SLIDER ORA SEGUE LA LARGHEZZA DELL'IMMAGINE */
:deep(.splide) {
  max-width: 900px;
  margin: 0 auto;
}

/* Frecce a 10px dal bordo */
:deep(.splide__arrow--prev) {
  left: -40px;
}

:deep(.splide__arrow--next) {
  right: -40px;
}
</style>